import { FormControlLabel, SxProps, Switch, Theme } from "@mui/material";
import Flex from "./Flex";
import Text from "./Text";
import { CHART_COLORS, CHART_TYPOGRAPHY } from "./app/provider/patient/chart";

export type ToggleSettingItem = {
  id: string;
  label: string;
  disabled?: boolean;
};

export type ToggleSettingListProps = {
  items: ToggleSettingItem[];
  /** Checked state per item id; a missing id reads as off. */
  values: Record<string, boolean>;
  onChange: (id: string, checked: boolean) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * Rows of "label — switch" for settings panels.
 *
 * @author Rajkumar Rathod
 */
const ToggleSettingList = ({
  items,
  values,
  onChange,
  disabled,
  sx,
}: ToggleSettingListProps) => {
  return (
    <Flex flexDirection="column" gap={1} sx={sx}>
      {items.map((item) => (
        <FormControlLabel
          key={item.id}
          labelPlacement="start"
          disabled={disabled || item.disabled}
          checked={!!values[item.id]}
          onChange={(_, checked) => onChange(item.id, checked)}
          control={<Switch size="small" />}
          label={
            <Text {...CHART_TYPOGRAPHY.body4} c={CHART_COLORS.textDark}>
              {item.label}
            </Text>
          }
          sx={{
            m: 0,
            justifyContent: "space-between",
            width: "100%",
          }}
        />
      ))}
    </Flex>
  );
};

export default ToggleSettingList;
